// src/components/RedeemSliderModal.js
import React, { useState, useRef, useEffect } from 'react';
import couponImg from '../assets/coupon.png';

const RedeemSliderModal = ({ onRedeem, onClose }) => {
  const [thumbX, setThumbX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [excitement, setExcitement] = useState(0);
  const [redeemed, setRedeemed] = useState(false);
  const containerRef = useRef(null);
  const startXRef = useRef(0);
  const maxX = 230;

  const updateExcitement = (x) => {
    const progress = x / maxX;
    if (progress > 0.75) setExcitement(3);
    else if (progress > 0.5) setExcitement(2);
    else if (progress > 0.25) setExcitement(1);
    else setExcitement(0);
  };

  const spawnParticles = () => {
    const container = document.getElementById('redeem-particles');
    if (!container) return;
    
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    
    const cx = rect.left + rect.width - 35;
    const cy = rect.top + rect.height / 2;
    
    for (let i = 0; i < 15; i++) {
      const particle = document.createElement('img');
      particle.src = couponImg;
      particle.className = 'redeem-particle';
      particle.style.left = cx + 'px';
      particle.style.top = cy + 'px';
      
      const angle = (Math.PI * 2 * i) / 15 + Math.random() * 0.5;
      const distance = 80 + Math.random() * 120;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance - 30;
      const rot = (Math.random() - 0.5) * 720;
      
      particle.style.setProperty('--tx', tx + 'px');
      particle.style.setProperty('--ty', ty + 'px');
      particle.style.setProperty('--rot', rot + 'deg');
      
      container.appendChild(particle);
      setTimeout(() => particle.remove(), 1500);
    }
  };

  const handleComplete = () => {
    setRedeemed(true);
    spawnParticles();
    setTimeout(() => {
      onRedeem();
    }, 800);
  };

  const handleRelease = () => {
    setIsDragging(false);
    setExcitement(0);
    if (thumbX >= maxX * 0.9) {
      handleComplete();
    } else {
      setThumbX(0);
    }
  };

  // Mouse events
  const handleMouseDown = (e) => {
    setIsDragging(true);
    startXRef.current = e.clientX - thumbX;
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const newX = Math.max(0, Math.min(maxX, e.clientX - startXRef.current));
      setThumbX(newX);
      updateExcitement(newX);
    };

    const handleMouseUp = () => {
      if (isDragging) handleRelease();
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, thumbX]);

  // Touch events
  const handleTouchStart = (e) => {
    setIsDragging(true);
    startXRef.current = e.touches[0].clientX - thumbX;
  };

  useEffect(() => {
    const handleTouchMove = (e) => {
      if (!isDragging) return;
      const newX = Math.max(0, Math.min(maxX, e.touches[0].clientX - startXRef.current));
      setThumbX(newX);
      updateExcitement(newX);
    };

    const handleTouchEnd = () => {
      if (isDragging) handleRelease();
    };

    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDragging, thumbX]);

  const excitementClass = excitement > 0 ? `excitement-${excitement}` : '';
  const successClass = redeemed ? 'success' : '';

  return (
    <div className="redeem-modal-overlay" onClick={onClose}>
      <div id="redeem-particles" className="redeem-particles-container"></div>
      <div className="redeem-modal" onClick={e => e.stopPropagation()}>
        <h3>Redeem Coupon</h3>
        <p>Slide to confirm</p>
        
        <div className="redeem-slider-container" ref={containerRef}>
          <div className="redeem-slider-track">
            {redeemed ? '🎉 Redeemed!' : 'Slide to redeem →'}
          </div>
          <div 
            className={`redeem-slider-thumb ${excitementClass} ${successClass}`}
            style={{ left: `${5 + thumbX}px` }}
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
          >
            <img src={couponImg} alt="coupon" />
          </div>
        </div>
        
        <button className="redeem-cancel-btn" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default RedeemSliderModal;
